export default "__VITE_ASSET__JKxl6f2A__"